export const USER_ID_KEY = "user_id2";
export const USER_DETAILS_KEY = "user_details2";